import React from 'react'
import BarChart from '../Components/Charts/BarChart';
import monthsParser from '../Utils/monthsParser';

const Charts = ({ data }) => {

    return (
        <div className="grid grid-cols-2 mx-5 my-10 gap-4">
            {/* Monthly Results */}
            <div className="py-4">
                <div className="font-bold text-xl text-center text-label mb-3 sm:text-sm">Monthly <span className='text-pinegreen text-xl'>{ monthsParser(data.month) }</span></div>
                {
                    data.monthlyResults.length === 0 ? <div className='text-center text-label text-lg italic'>No data available</div> :
                    data.monthlyResults.map((client, i) => (
                        <div key={i} className='grid grid-cols-7 gap-2 rounded-lg overflow-hidden p-5 mb-10 border-solid border-2 border-mossgreen'>
                            <div className="w-6 flex items-center justify-center">
                                <span className='font-bold text-2xl text-label col-span-1 -rotate-90'>
                                    { client.name }
                                </span>
                            </div>
                            {
                                client.categories.map((category, index) => (
                                    <div key={index} className='h-52 px-3 col-span-2'>
                                        <BarChart data={category} />
                                    </div>
                                ))
                            }
                        </div>
                    ))
                }
            </div>

            {/* Year Results */}
            <div className="py-4">
                <div className="font-bold text-xl text-center text-label mb-3 sm:text-sm">Year-To-Date <span className='text-pinegreen text-xl'>{ data.year }</span></div>
                {
                    data.yearResults.map((client, index) => (
                        <div key={index} className='grid grid-cols-7 gap-2 rounded-lg overflow-hidden p-5 mb-10 border-solid border-2 border-mossgreen'>
                            <div className="w-6 flex items-center justify-center">
                                <span className='font-bold text-2xl text-label col-span-1 -rotate-90'>
                                    { client.name }
                                </span>
                            </div>
                            {
                                client.categories.map((category, index) => (
                                    <div key={index} className='h-52 px-3 col-span-2'>
                                        <BarChart data={category} />
                                    </div>
                                ))
                            }
                        </div>
                    ))
                }
            </div>
        </div>
    )
}
export default Charts;